module.exports = __webpack_public_path__ + "static/media/ic_ccm_form_logo.69ea4a57.jpg";